<p-tieredMenu #menu [appendTo]="internalOptions.minimized ? 'body' : ''" [model]="languageOptions" [popup]="true" />

@if (!internalOptions.minimized) {
    <div
        class="transition-[colors, width] flex h-12 items-center gap-5 pl-8 text-primary-light duration-200 ease-in-out hover:text-white xl:w-72"
        [ngClass]="[isExtended ? 'w-72' : 'w-24']"
    >
        <span class="w-6 text-inherit">{{ currentLocale | uppercase }}</span>
        <button
            type="button"
            class="w-0 whitespace-nowrap bg-primary px-0 text-inherit opacity-0 transition-opacity duration-200 ease-in-out"
            [ngClass]="{
                'w-fit opacity-100': isExtended,
                'xl:w-fit xl:opacity-100': internalOptions.alwaysExtendAfterXL
            }"
            (click)="menu.toggle($event)"
            (keypress)="menu.toggle($event)"
        >
            {{ localizedLanguages[currentLocale] }}
            <fa-icon class="ml-2" [icon]="faCaretDown" />
        </button>
    </div>
} @else {
    <button type="button" [class]="internalOptions.textClassMini" (click)="menu.toggle($event)" (keypress)="menu.toggle($event)">
        {{ currentLocale | uppercase }}
        <fa-icon class="ml-2" [icon]="faCaretDown" />
    </button>
}
